import Enum from './Enum'
class HttpErrorEnum extends Enum {
  constructor() {
    super()
    this.SERVER_ERROR = 0
    this.UNAUTHORIZED = 1
  }
}

export default Object.freeze(new HttpErrorEnum())
